module.exports = __webpack_public_path__ + "static-portal/img/1.de204f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/1.jpg
// module id = ZQ7x
// module chunks = 4